import dataBeleidNietErnstigDoac from "../../../../src/data/niet-ernstige-bloedingen-onder-doac.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBeleidNietErnstigDoac,
  BasicSchematic,
  React
};